export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
};

const ApiRoutes = {
  Dashboard: {
    Data: {
      Endpoint: "/dashboard",
      Method: HttpMethod.Post,
    },
    Incharge: {
      Endpoint: "/InchargeDashboard",
      Method: HttpMethod.Post,
    },
    Franchise: {
      Endpoint: "/franchiseDashboard",
      Method: HttpMethod.Post,
    },
    staffDetail: {
      Endpoint: "/staffDetail",
      Method: HttpMethod.Post,
    },
    getNotification: {
      Endpoint: "/getNotification",
      Method: HttpMethod.Post,
    },
    readNotification: {
      Endpoint: "/notificationRead",
      Method: HttpMethod.Post,
    },
  },
  Auth: {
    Login: {
      Endpoint: "/login",
      Method: HttpMethod.Post,
    },
  },
  User: {
    All: {
      Endpoint: "/getAllUser",
      Method: HttpMethod.Post,
    },
    UserById: {
      Endpoint: "/getUserById",
      Method: HttpMethod.Post,
    },
    UserActive: {
      Endpoint: "/userActive",
      Method: HttpMethod.Post,
    },
  },
  Transaction: {
    AllFrTransaction: {
      Endpoint: "/getAllFranchiseTransaction",
      Method: HttpMethod.Post,
    },
    AllUserTransaction: {
      Endpoint: "/getTransaction",
      Method: HttpMethod.Post,
    },
    FranchiseTransaction: {
      Endpoint: "/getFranchiseTransaction",
      Method: HttpMethod.Post,
    },
    UserTransaction: {
      Endpoint: "/getUserTransaction",
      Method: HttpMethod.Post,
    },
    CommissionHistory: {
      Endpoint: "/getAllInchargeCommission",
      Method: HttpMethod.Post,
    },
    CommissionDetail: {
      Endpoint: "/getInchargeCommissionDetail",
      Method: HttpMethod.Post,
    },
    UserOrderDetailTransaction: {
      Endpoint: "/getUserCartDetail",
      Method: HttpMethod.Post,
    },
    FranchiseOrderDetailTransaction: {
      Endpoint: "/getFranchiseCartDetail",
      Method: HttpMethod.Post,
    },
    StatusTrackUpdate: {
      Endpoint: "/orderStatus",
      Method: HttpMethod.Post,
    },
    VerifyTokenOrder: {
      Endpoint: "/verifyTokenOrder",
      Method: HttpMethod.Post,
    },
    ResendOrderToken: {
      Endpoint: "/resendOrderToken",
      Method: HttpMethod.Post,
    },
    GetDspInventory: {
      Endpoint: "/getDspInventory",
      Method: HttpMethod.Post,
    },
    CheckDspStock: {
      Endpoint: "/checkDspStock",
      Method: HttpMethod.Post,
    },
    CodAccept: {
      Endpoint: "/codPaymentAccept",
      Method: HttpMethod.Post,
    },
    SendCODOTP: {
      Endpoint: "/sendCODOTP",
      Method: HttpMethod.Post,
    },
    ReSendCODOTP: {
      Endpoint: "/resendCODOTP",
      Method: HttpMethod.Post,
    },
    VerifyCOD: {
      Endpoint: "/verifyCODOTP",
      Method: HttpMethod.Post,
    },
  },
  Company: {
    Add: {
      Endpoint: "/addCompany",
      Method: HttpMethod.Post,
    },
    Edit: {
      Endpoint: "/editCompany",
      Method: HttpMethod.Post,
    },
    Get: {
      Endpoint: "/getAllCompany",
      Method: HttpMethod.Post,
    },
    GetId: {
      Endpoint: "/getCompanyById",
      Method: HttpMethod.Post,
    },
  },
  CheckOut: {
    Data: {
      Endpoint: "/addAllCart",
      Method: HttpMethod.Post,
    },
  },
  Order: {
    AllFranchiseComplete: {
      Endpoint: "/getAllFranchiseTransaction",
      Method: HttpMethod.Post,
    },
    AllFranchisePending: {
      Endpoint: "/getAllFranchiseCOD",
      Method: HttpMethod.Post,
    },
    AllUserComplete: {
      Endpoint: "/getAllUserTransaction",
      Method: HttpMethod.Post,
    },
    AllUserPending: {
      Endpoint: "/getAllUserCOD",
      Method: HttpMethod.Post,
    },
  },
  Cod: {
    Cod: {
      Endpoint: "/franchiseProductCOD",
      Method: HttpMethod.Post,
    },
    RazorpayCreateOrder: {
      Endpoint: "/payment/razorpay/create-order",
      Method: HttpMethod.Post,
    },
    RazorpayVerify: {
      Endpoint: "/payment/razorpay/verify-payment",
      Method: HttpMethod.Post,
    },
    Wallet: {
      Endpoint: "/franchiseProductWallet",
      Method: HttpMethod.Post,
    },
    DspCashCreateOrder: {
      Endpoint: "/payment/dsp-cash/create-order",
      Method: HttpMethod.Post,
    },
    DspCashVerify: {
      Endpoint: "/payment/dsp-cash/verify-payment",
      Method: HttpMethod.Post,
    },
  },
  Banner: {
    All: {
      Endpoint: "/getAllBanner",
      Method: HttpMethod.Post,
    },
    BannerById: {
      Endpoint: "/getBannerById",
      Method: HttpMethod.Post,
    },
    AddBanner: {
      Endpoint: "/addBanner",
      Method: HttpMethod.Post,
    },
    EditBanner: {
      Endpoint: "/updateBanner",
      Method: HttpMethod.Post,
    },
    DeleteBanner: {
      Endpoint: "/deleteBanner",
      Method: HttpMethod.Post,
    },
  },
  MyCard: {
    Endpoint: "/getProfileDetail",
    Method: HttpMethod.Post,
  },
  Category: {
    All: {
      Endpoint: "/getAllCategory",
      Method: HttpMethod.Post,
    },
    CategoryById: {
      Endpoint: "/getCategoryById",
      Method: HttpMethod.Post,
    },
    AddCategory: {
      Endpoint: "/addCategory",
      Method: HttpMethod.Post,
    },
    EditCategory: {
      Endpoint: "/updateCategory",
      Method: HttpMethod.Post,
    },
    DeleteCategory: {
      Endpoint: "/deleteCategory",
      Method: HttpMethod.Post,
    },
  },
  Attendence: {
    All: {
      Endpoint: "/getAllAttendence",
      Method: HttpMethod.Post,
    },
    AttendenceById: {
      Endpoint: "/getAttendenceById",
      Method: HttpMethod.Post,
    },
    AddAttendence: {
      Endpoint: "/addAttendence",
      Method: HttpMethod.Post,
    },
    EditAttendence: {
      Endpoint: "/updateAttendence",
      Method: HttpMethod.Post,
    },
    DeleteAttendence: {
      Endpoint: "/deleteAttendence",
      Method: HttpMethod.Post,
    },
  },
  Holiday: {
    All: {
      Endpoint: "/getAllHoliday",
      Method: HttpMethod.Post,
    },
    HolidayById: {
      Endpoint: "/getHolidayById",
      Method: HttpMethod.Post,
    },
    AddHoliday: {
      Endpoint: "/addHoliday",
      Method: HttpMethod.Post,
    },
    EditHoliday: {
      Endpoint: "/updateHoliday",
      Method: HttpMethod.Post,
    },
    DeleteHoliday: {
      Endpoint: "/deleteHoliday",
      Method: HttpMethod.Post,
    },
  },

  SubCategory: {
    All: {
      Endpoint: "/getAllSubCategory",
      Method: HttpMethod.Post,
    },
    SubCategoryById: {
      Endpoint: "/getSubCategoryById",
      Method: HttpMethod.Post,
    },
    subCategoryByCategoryIdConfig: {
      Endpoint: "/getSubCategoryByCategoryId",
      Method: HttpMethod.Post,
    },
    AddSubCategory: {
      Endpoint: "/addSubCategory",
      Method: HttpMethod.Post,
    },
    EditSubCategory: {
      Endpoint: "/updateSubCategory",
      Method: HttpMethod.Post,
    },
    DeleteSubCategory: {
      Endpoint: "/deleteSubCategory",
      Method: HttpMethod.Post,
    },
  },

  Product: {
    All: {
      Endpoint: "/getAllProduct",
      Method: HttpMethod.Post,
    },
    AllProductFrencise: {
      Endpoint: "/getFranchiseProduct",
      Method: HttpMethod.Post,
    },
    ProductById: {
      Endpoint: "/getProductById",
      Method: HttpMethod.Post,
    },
    AddProduct: {
      Endpoint: "/addProduct",
      Method: HttpMethod.Post,
    },
    addProductVarients: {
      Endpoint: "/addProductVarients",
      Method: HttpMethod.Post,
    },
    EditProduct: {
      Endpoint: "/updateProduct",
      Method: HttpMethod.Post,
    },
    EditProductVariant: {
      Endpoint: "/updateProductVarients",
      Method: HttpMethod.Post,
    },
    DeleteProduct: {
      Endpoint: "/deleteProduct",
      Method: HttpMethod.Post,
    },
    updateInventory: {
      Endpoint: "/updateInventory",
      Method: HttpMethod.Post,
    },
  },
  Frencise: {
    All: {
      // Endpoint: "/getAllFrencise",
      Endpoint: "/getAllStaffFranchise",
      Method: HttpMethod.Post,
    },
    FrenciseAccept: {
      // Endpoint: "/getAllFrencisePending",
      Endpoint: "/getAllPendingStaffFranchise",
      Method: HttpMethod.Post,
    },
    FrenciseById: {
      // Endpoint: "/getFrenciseById",
      Endpoint: "/getStaffByIdFranchise",
      Method: HttpMethod.Post,
    },
    FrenciseCheck: {
      Endpoint: "/frenciseCheck",
      Method: HttpMethod.Post,
    },
    AddFrencise: {
      // Endpoint: "/addFrencise",
      Endpoint: "/addStaffFranchise",
      Method: HttpMethod.Post,
    },
    EditFrencise: {
      // Endpoint: "/editFrencise",
      Endpoint: "/editStaffFranchise",
      Method: HttpMethod.Post,
    },
    Order: {
      Endpoint: "/getFrenchiseOrder",
      Method: HttpMethod.Post,
    },
    DeleteFrencise: {
      Endpoint: "/deleteFrencise",
      Method: HttpMethod.Post,
    },
  },
  Farmer: {
    All: {
      Endpoint: "/getAllServiceRequest",
      Method: HttpMethod.Post,
    },
    FarmerById: {
      Endpoint: "/getServiceRequestById",
      Method: HttpMethod.Post,
    },
    AddFarmer: {
      Endpoint: "/addServiceRequest",
      Method: HttpMethod.Post,
    },
    EditFarmer: {
      Endpoint: "/updateFarmer",
      Method: HttpMethod.Post,
    },
    DeleteFarmer: {
      Endpoint: "/deleteFarmer",
      Method: HttpMethod.Post,
    },
  },
  District: {
    AllDistrict: {
      Endpoint: "/getAllDistrict",
      Method: HttpMethod.Post,
    },
    DistrictById: {
      Endpoint: "/getDistrictById",
      Method: HttpMethod.Post,
    },
    DistrictByStateId: {
      Endpoint: "/getDistrictByStateId",
      Method: HttpMethod.Post,
    },
    AddDistrict: {
      Endpoint: "/addDistrict",
      Method: HttpMethod.Post,
    },
    EditDistrict: {
      Endpoint: "/updateDistrict",
      Method: HttpMethod.Post,
    },
    DeleteDistrict: {
      Endpoint: "/deleteDistrict",
      Method: HttpMethod.Post,
    },
  },
  State: {
    AllState: {
      Endpoint: "/getAllState",
      Method: HttpMethod.Post,
    },
    StateById: {
      Endpoint: "/getStateById",
      Method: HttpMethod.Post,
    },
    AddState: {
      Endpoint: "/addState",
      Method: HttpMethod.Post,
    },
    EditState: {
      Endpoint: "/updateState",
      Method: HttpMethod.Post,
    },
    DeleteState: {
      Endpoint: "/deleteState",
      Method: HttpMethod.Post,
    },
  },
  Block: {
    AllBlock: {
      Endpoint: "/getAllBlock",
      Method: HttpMethod.Post,
    },
    BlockById: {
      Endpoint: "/getBlockById",
      Method: HttpMethod.Post,
    },
    AddBlock: {
      Endpoint: "/addBlock",
      Method: HttpMethod.Post,
    },
    EditBlock: {
      Endpoint: "/editBlock",
      Method: HttpMethod.Post,
    },
    DeleteBlock: {
      Endpoint: "/deleteBlock",
      Method: HttpMethod.Post,
    },
  },
  Cluster: {
    AllCluster: {
      Endpoint: "/getAllCluster",
      Method: HttpMethod.Post,
    },
    ClusterById: {
      Endpoint: "/getClusterById",
      Method: HttpMethod.Post,
    },
    AddCluster: {
      Endpoint: "/addCluster",
      Method: HttpMethod.Post,
    },
    EditCluster: {
      Endpoint: "/editCluster",
      Method: HttpMethod.Post,
    },
    DeleteCluster: {
      Endpoint: "/deleteCluster",
      Method: HttpMethod.Post,
    },
  },
  FranchiseState: {
    AllFranchiseState: {
      // Endpoint: "/getAllStateFranchise",
      Endpoint: "/getAllStaffFranchise",
      Method: HttpMethod.Post,
    },
    FranchiseStateById: {
      // Endpoint: "/getStateFranchiseById",
      Endpoint: "/getStaffByIdFranchise",
      Method: HttpMethod.Post,
    },
    AddFranchiseState: {
      // Endpoint: "/addStateFranchise",
      Endpoint: "/addStaffFranchise",
      Method: HttpMethod.Post,
    },
    EditFranchiseState: {
      // Endpoint: "/editStateFranchise",
      Endpoint: "/editStaffFranchise",
      Method: HttpMethod.Post,
    },
    DeleteFranchiseState: {
      Endpoint: "/deleteStateFranchise",
      Method: HttpMethod.Post,
    },
    PendingStateFranchise: {
      // Endpoint: "/getAllPendingStateFranchise",
      Endpoint: "/getAllPendingStaffFranchise",
      Method: HttpMethod.Post,
    },
    frenciseStateAccept: {
      Endpoint: "/frenciseStateAccept",
      Method: HttpMethod.Post,
    },
  },
  FranchiseDivision: {
    AccpetDivision: {
      // Endpoint: "/getAllDivisionFranchise",
      Endpoint: "/getAllStaffFranchise",
      Method: HttpMethod.Post,
    },
    GetDivisionByID: {
      // Endpoint: "/getDivisionFranchiseById",
      Endpoint: "/getStaffByIdFranchise",
      Method: HttpMethod.Post,
    },
    AddDivision: {
      // Endpoint: "/addDivisionFranchise",
      Endpoint: "/addStaffFranchise",
      Method: HttpMethod.Post,
    },
    EditDivision: {
      // Endpoint: "/editDivisionFranchise",
      Endpoint: "/editStaffFranchise",
      Method: HttpMethod.Post,
    },
    DeleteDivision: {
      Endpoint: "/deleteDivisionFranchise",
      Method: HttpMethod.Post,
    },
    PendingDivision: {
      // Endpoint: "/getAllPendingDivisionFranchise",
      Endpoint: "/getAllPendingStaffFranchise",
      Method: HttpMethod.Post,
    },
    frenciseDivisionAccept: {
      Endpoint: "/frenciseDivisionAccept",
      Method: HttpMethod.Post,
    },
  },
  FranchiseBlock: {
    AllFranchiseBlock: {
      // Endpoint: "/getAllBlockFranchise",
      Endpoint: "/getAllStaffFranchise",
      Method: HttpMethod.Post,
    },
    FranchiseBlockById: {
      // Endpoint: "/getBlockFranchiseById",
      Endpoint: "/getStaffByIdFranchise",
      Method: HttpMethod.Post,
    },
    AddFranchiseBlock: {
      // Endpoint: "/addBlockFranchise",
      Endpoint: "/addStaffFranchise",
      Method: HttpMethod.Post,
    },
    EditFranchiseBlock: {
      // Endpoint: "/editBlockFranchise",
      Endpoint: "/editStaffFranchise",
      Method: HttpMethod.Post,
    },
    DeleteFranchiseBlock: {
      Endpoint: "/deleteBlockFranchise",
      Method: HttpMethod.Post,
    },
    PendingBlockFranchise: {
      // Endpoint: "/getAllPendingBlockFranchise",
      Endpoint: "/getAllPendingStaffFranchise",
      Method: HttpMethod.Post,
    },
    AcceptFranchiseBlock: {
      Endpoint: "/frenciseBlockAccept",
      Method: HttpMethod.Post,
    },
  },

  Settlement: {
    GETSettlment: {
      Endpoint: "/getSettlement",
      Method: HttpMethod.Post,
    },
    Wallet: {
      Endpoint: "/getWallet",
      Method: HttpMethod.Post,
    },
    Franchise: {
      Endpoint: "/getFranchiseLeadger",
      Method: HttpMethod.Post,
    },
    Detail: {
      Endpoint: "/getInchargeSettlementDetail",
      Method: HttpMethod.Post,
    },
    SettlementUpdate: {
      Endpoint: "/settlementUpdate",
      Method: HttpMethod.Post,
    },
  },
  WeeklySettlement: {
    Run: {
      Endpoint: "/settlement/weekly/run",
      Method: HttpMethod.Post,
    },
    History: {
      Endpoint: "/settlement/weekly/history",
      Method: HttpMethod.Get,
    },
    Ledger: {
      Endpoint: "/settlement/ledger",
      Method: HttpMethod.Get,
    },
    AssignKit: {
      Endpoint: "/settlement/joining-kit/assign",
      Method: HttpMethod.Post,
    },
    ListKits: {
      Endpoint: "/joining-kit/list",
      Method: HttpMethod.Get,
    },
    CreateKitOrder: {
      Endpoint: "/settlement/joining-kit/create-order",
      Method: HttpMethod.Post,
    },
    PurchaseKit: {
      Endpoint: "/settlement/joining-kit/purchase",
      Method: HttpMethod.Post,
    },
    MyKitStatus: {
      Endpoint: "/settlement/joining-kit/my-status",
      Method: HttpMethod.Get,
    },
    AdminListKits: {
      Endpoint: "/joining-kit/admin/list",
      Method: HttpMethod.Get,
    },
    AdminUpdateKit: {
      Endpoint: "/joining-kit/admin/update",
      Method: HttpMethod.Post,
    },
    AdminCreateKit: {
      Endpoint: "/joining-kit/admin/create",
      Method: HttpMethod.Post,
    },
  },
  FranchiseCluster: {
    AllFranchiseCluster: {
      // Endpoint: "/getAllClusterFranchise",
      Endpoint: "/getAllStaffFranchise",
      Method: HttpMethod.Post,
    },
    FranchiseClusterById: {
      // Endpoint: "/getClusterFranchiseById",
      Endpoint: "/getStaffByIdFranchise",
      Method: HttpMethod.Post,
    },
    AddFranchiseCluster: {
      // Endpoint: "/addClusterFranchise",
      Endpoint: "/addStaffFranchise",
      Method: HttpMethod.Post,
    },
    EditFranchiseCluster: {
      // Endpoint: "/editClusterFranchise",
      Endpoint: "/editStaffFranchise",
      Method: HttpMethod.Post,
    },
    DeleteFranchiseCluster: {
      Endpoint: "/deleteClusterFranchise",
      Method: HttpMethod.Post,
    },
    PendingClusterFranchise: {
      // Endpoint: "/getAllPendingClusterFranchise",
      Endpoint: "/getAllPendingStaffFranchise",
      Method: HttpMethod.Post,
    },
    frenciseClusterAccept: {
      Endpoint: "/frenciseClusterAccept",
      Method: HttpMethod.Post,
    },
  },
  FranchiseVillage: {
    AllFranchiseVillage: {
      // Endpoint: "/getAllVillageFranchise",
      Endpoint: "/getAllStaffFranchise",
      Method: HttpMethod.Post,
    },
    FranchiseVillageById: {
      // Endpoint: "/getVillageFranchiseById",
      Endpoint: "/getStaffByIdFranchise",
      Method: HttpMethod.Post,
    },
    AddFranchiseVillage: {
      Endpoint: "/addStaffFranchise",
      Method: HttpMethod.Post,
    },
    EditFranchiseVillage: {
      // Endpoint: "/editVillageFranchise",
      Endpoint: "/editStaffFranchise",
      Method: HttpMethod.Post,
    },
    DeleteFranchiseVillage: {
      Endpoint: "/deleteVillageFranchise",
      Method: HttpMethod.Post,
    },
    AcceptFranchiseVillage: {
      Endpoint: "/frenciseVillageAccept",
      Method: HttpMethod.Post,
    },
    PendingFranchiseVillage: {
      Endpoint: "/getAllPendingStaffFranchise",
      Method: HttpMethod.Post,
    },
    AddFieldOfficer: {
      Endpoint: "/add-field-officer",
      method: HttpMethod.Post,
    },
    acceptStaffFranchise: {
      Endpoint: "/acceptStaffFranchise",
      method: HttpMethod.Post,
    },
    rejectStaffFranchise: {
      Endpoint: "/rejectStaffFranchise",
      method: HttpMethod.Post,
    },
  },
  Commissiom: {
    All: {
      Endpoint: "/getAllCommission",
      Method: HttpMethod.Post,
    },
    CommissiomById: {
      Endpoint: "/getCommissionById",
      Method: HttpMethod.Post,
    },
    AddCommissiom: {
      Endpoint: "/addCommission",
      Method: HttpMethod.Post,
    },
    EditCommissiom: {
      Endpoint: "/updateCommission",
      Method: HttpMethod.Post,
    },
    DeleteCommissiom: {
      Endpoint: "/deleteCommission",
      Method: HttpMethod.Post,
    },
  },
  FranchiseUser: {
    AllFrenchiseUser: {
      Endpoint: "/getAllFrenchiseUser",
      Method: HttpMethod.Post,
    },
    CommissiomById: {
      Endpoint: "/getCommissionById",
      Method: HttpMethod.Post,
    },
    GetFarmerOnline: {
      Endpoint: "/getFranchiseUserOnline",
      Method: HttpMethod.Post,
    },
    GetFarmerCod: {
      Endpoint: "/getFranchiseUserCOD",
      Method: HttpMethod.Post,
    },
  },
  View: {
    GetLedger: {
      Endpoint: "/getLeadger",
      Method: HttpMethod.Post,
    },
    GetContactLead: {
      Endpoint: "/getcontactUsLead",
      Method: HttpMethod.Post,
    },
    deleteContactUsLead: {
      Endpoint: "/deleteContactUsLead",
      Method: HttpMethod.Post,
    },
    ledgerDetail: {
      Endpoint: "/getFranchiseLeadgerDetail",
      Method: HttpMethod.Post,
    },
    GetWallet: {
      Endpoint: "/getWallet",
      Method: HttpMethod.Post,
    },
    GetUnderIncharge: {
      Endpoint: "/UnderIncharge",
      Method: HttpMethod.Post,
    },
    GetCommission: {
      Endpoint: "/getInchargeCommmissionAll",
      Method: HttpMethod.Post,
    },
  },
  StaffTree: {
    GetStaffNetworkTree: {
      Endpoint: "/getStaffNetworkTree",
      Method: HttpMethod.Post,
    },
  },
  Incentives: {
    CreateCampaign: {
      Endpoint: "/createCampaign",
      Method: HttpMethod.Post,
    },
    GetAllCampaigns: {
      Endpoint: "/getAllCampaigns",
      Method: HttpMethod.Get,
    },
    UpdateCampaign: {
      Endpoint: "/updateCampaign",
      Method: HttpMethod.Post,
    },
    DeleteCampaign: {
      Endpoint: "/deleteCampaign",
      Method: HttpMethod.Post,
    },
    GetAdminDistributions: {
      Endpoint: "/getAdminDistributions",
      Method: HttpMethod.Get,
    },
    UpdateDistributionStatus: {
      Endpoint: "/updateDistributionStatus",
      Method: HttpMethod.Post,
    },
    ClaimReward: {
      Endpoint: "/claimReward",
      Method: HttpMethod.Post,
    },
    GetMyAwards: {
      Endpoint: "/getMyAwards",
      Method: HttpMethod.Get,
    },
  },
};

export default ApiRoutes;
